import {Dispatch} from 'redux';
import {
  Group,
  GroupClinic,
  GroupHealthCareProvider,
  GroupUser
} from '../../services/service-mappers/ClinicServiceMapper';
import {SetLogoutAuth} from './CommonActionMapper';
import {
  SET_ALL_GROUPS,
  SET_SELECTED_GROUP_CLINICS,
  SET_SELECTED_GROUP_USERS,
  SET_SELECTED_GROUP,
  SET_GROUP_USERS,
  SET_GROUP_CLINICS,
  SET_SELECTED_GROUP_CARD_MACHINES,
  SET_ACCESS_OF_CLINICS,
  SET_SELECTED_GROUP_ID,
  RESET_GROUP_STATE,
  SET_SELECTED_GROUP_HEALTHCARE_PROVIDERS,
  SET_SELECTED_GROUP_ENABLED_MODULES
} from './Index';

// Action Types
interface SetAllGroupAction {
  type: typeof SET_ALL_GROUPS;
  payload: {
    groups: Group[];
  };
}

interface SetSelectedGroupAction {
  type: typeof SET_SELECTED_GROUP;
  payload: {
    selectedGroup: Group;
  };
}

interface SetSelectedGroupUsersAction {
  type: typeof SET_SELECTED_GROUP_USERS;
  payload: {
    groupUsers: GroupUser[];
  };
}

interface SetSelectedGroupClinicsAction {
  type: typeof SET_SELECTED_GROUP_CLINICS;
  payload: {
    groupClinics: GroupClinic[];
  };
}

interface SetGroupClinicsAction {
  type: typeof SET_GROUP_CLINICS;
  payload: {
    groupId: Group['id'];
    groupClinics: GroupClinic[];
  };
}

interface SetGroupUsersAction {
  type: typeof SET_GROUP_USERS;
  payload: {
    groupId: Group['id'];
    groupUsers: GroupUser[];
  };
}

interface SetGroupCardMachinesAction {
  type: typeof SET_SELECTED_GROUP_CARD_MACHINES;
  payload: {
    modules?: any;
    // TODO: ADD TYPES
    cardMachines: any;
  };
}

interface SetGroupHealthCareProvidersAction {
  type: typeof SET_SELECTED_GROUP_HEALTHCARE_PROVIDERS;
  payload: {
    // TODO: ADD TYPES
    providers: GroupHealthCareProvider[];
  };
}

interface SetAccessOfClinicsAction {
  type: typeof SET_ACCESS_OF_CLINICS;
  payload: {
    accessOfClinics: any[];
  };
}

interface SetSelectedGroupIdAction {
  type: typeof SET_SELECTED_GROUP_ID;
  payload: {
    groupId: null | Group['id'];
  };
}

interface ResetGroupStateAction {
  type: typeof RESET_GROUP_STATE;
  payload?: never;
}

interface SetGroupEnabledModulesAction {
  type: typeof SET_SELECTED_GROUP_ENABLED_MODULES;
  payload: {
    // TODO: ADD TYPES
    modules: any[];
  };
}

export type ClinicGroupAction =
  | SetAllGroupAction
  | SetSelectedGroupAction
  | SetSelectedGroupUsersAction
  | SetSelectedGroupClinicsAction
  | SetGroupClinicsAction
  | SetGroupUsersAction
  | SetGroupCardMachinesAction
  | SetAccessOfClinicsAction
  | SetSelectedGroupIdAction
  | ResetGroupStateAction
  | SetLogoutAuth
  | SetGroupHealthCareProvidersAction
  | SetGroupEnabledModulesAction

// Action creators
export const _setAllGroups = (groups: any[]): any => async (
  dispatch: Dispatch<ClinicGroupAction>
) => {
  dispatch({type: SET_ALL_GROUPS, payload: {groups}});
};

export const _setSelectedGroup = (selectedGroup: any): any => async (
  dispatch: Dispatch<ClinicGroupAction>
) => {
  dispatch({type: SET_SELECTED_GROUP, payload: {selectedGroup}});
};

// set selected group's users
export const _setSelectedGroupUsers = (groupUsers: any): any => async (
  dispatch: Dispatch<ClinicGroupAction>
) => {
  dispatch({
    type: SET_SELECTED_GROUP_USERS,
    payload: {groupUsers}
  });
};

export const _setSelectedGroupClinics = (groupClinics: any): any => async (
  dispatch: Dispatch<ClinicGroupAction>
) => {
  dispatch({
    type: SET_SELECTED_GROUP_CLINICS,
    payload: {groupClinics}
  });
};

export const _setGroupClinics = (
  groupId: any,
  groupClinics: any
): any => async (dispatch: Dispatch<ClinicGroupAction>) => {
  dispatch({
    type: SET_GROUP_CLINICS,
    payload: {groupId, groupClinics}
  });
};

export const _setGroupUsers = (groupId: any, groupUsers: any): any => async (
  dispatch: Dispatch<ClinicGroupAction>
) => {
  dispatch({
    type: SET_GROUP_USERS,
    payload: {groupId, groupUsers}
  });
};

export const _setSelectedGroupCardMachines = (cardMachines: any): any => async (
  dispatch: Dispatch<SetGroupCardMachinesAction>
) => {
  dispatch({
    type: SET_SELECTED_GROUP_CARD_MACHINES,
    payload: {
      cardMachines
    }
  });
};

export const _setAccessOfClinics = (accessOfClinics: any[]): any => async (
  dispatch: Dispatch<SetAccessOfClinicsAction>
) => {
  dispatch({
    type: SET_ACCESS_OF_CLINICS,
    payload: {
      accessOfClinics
    }
  });
};

export const _setSelectedClinicGroupId = (
  groupId: Group['id'] | null
): any => async (dispatch: Dispatch<SetSelectedGroupIdAction>) => {
  dispatch({
    type: SET_SELECTED_GROUP_ID,
    payload: {
      groupId
    }
  });
};

export const _resetGroupState = (): any => async (
  dispatch: Dispatch<ResetGroupStateAction>
) => {
  dispatch({
    type: RESET_GROUP_STATE
  });
};

export const _setSelectedGroupHealthCareProviders = (
  providers: GroupHealthCareProvider[]
): any => async (dispatch: Dispatch<SetGroupHealthCareProvidersAction>) => {
  dispatch({
    type: SET_SELECTED_GROUP_HEALTHCARE_PROVIDERS,
    payload: {
      providers
    }
  });
};

export const _setSelectedGroupEnabledModules = (
  modules: any
): any => async (dispatch: any) => {
  dispatch({
    type: SET_SELECTED_GROUP_ENABLED_MODULES,
    payload: {
      modules
    }
  })
}